import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router';
import { useNavigate, useLocation } from 'react-router-dom';
import { OutletContext } from '../../layout/Layout';
import PageTitleSubheader from '../../layout/subheader/PageTitleSubheader';
import { Card, CardBody } from '@patternfly/react-core';
import './Discover.scss';
import { DiscoverCategory, DiscoverContext, QuickFilter } from '../../types/discover';
import { TNewDateRange } from '../../api/types/TNewDateRange';
import { SubNavContext } from '../../helpers/sub-nav-contexts/sub-nav-context';
import { TQuestion } from '../../api/questions/Questions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import ChatInterface from '../../components/data-builder/ChatInterface';

type Props = {
	pageContext: DiscoverContext;
};
const AdvancedAI = (props: Props) => {
	const navigate = useNavigate();
	const { setSubSide, subNavExpanded, setSubNavExpanded } = useOutletContext<OutletContext>();
	const [searchTerm, setSearchTerm] = useState<string>('');
	const [categories, setCategories] = useState<DiscoverCategory[]>();
	const [hasLoadedCategories, setHasLoadedCategories] = useState<boolean>(false);
	const [quickFilters, setQuickFilters] = useState<QuickFilter[]>();
	const [filteredQuickFilters, setFilteredQuickFilters] = useState<QuickFilter[]>();
	const [_, setSelectedDate] = useState<TNewDateRange>();
	const [subNavContext, setSubNavContext] = useState<SubNavContext>();
	const [allQuestions, setAllQuestions] = useState<TQuestion[]>();
	const [aiSearchEnabled, setAiSearchEnabled] = useState(false);
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const termParam = params.get('term') ?? undefined;
	// initialTerm will be passed into the chat as the auto-submit message (if present)
	const initialTerm = termParam;

	useEffect(() => {
		setSubSide({
			subheaderContext: (
				<PageTitleSubheader
					pageTitle=""
					pageDescription=""
					subNavContext={undefined}
				/>
			),
			sidebarContext: null,
		});
	}, [setSubSide, subNavExpanded, setSubNavExpanded]);

	// update the search handler (URL-escape terms)
	const handleSearch = (_event: any, value: string) => {
		const encoded = encodeURIComponent(value || '');
		if (aiSearchEnabled) {
			navigate(`/discover/analyst?term=${encoded}`);
		} else {
			navigate(`/discover/search?term=${encoded}`);
		}
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter' && searchTerm && searchTerm.trim().length > 0) {
			const encoded = encodeURIComponent(searchTerm);
			if (aiSearchEnabled) {
				navigate(`/discover/analyst?term=${encoded}`);
			} else {
				navigate(`/discover/search?term=${encoded}`);
			}
		}
	};

	return (
		<Card className="discover-container advanced-ai-panel">
			<CardBody className="advanced-ai-body">
				<h1>
					<FontAwesomeIcon
						icon={faSparkles}
						style={{ paddingRight: '5px' }}
					/>
					<span className="insights-sticky-header__title">Advanced AI</span>
				</h1>
				<ChatInterface
					// context={chatContext}
					isSinglePage={true}
					externalThread={false}
					// onMessagesChange={setChatMessages}
					// onThinkingChange={setIsChatThinking}
					autoSubmitMessage={initialTerm}
					useInnovationAI={true}
					onAutoSubmitted={() => navigate('/discover/analyst', { replace: true })}
				/>
			</CardBody>
		</Card>
	);
};

export default AdvancedAI;
